export const VGS_DOC_UPLOAD_CSS = {
  width: '100%',
  height: '100%',
  position: 'absolute',
  input: {
    display: 'none'
  }
}